export default __STORYBOOKCOMPONENTSEXPERIMENTAL__;
const { Button, Icon, Input, Link, Select } = __STORYBOOKCOMPONENTSEXPERIMENTAL__;
export { Button, Icon, Input, Link, Select };